import FastMarquee from "react-fast-marquee";

const ITEMS = ["Architecture", "Construction", "Design-Build", "Construction Project Management", "One Contract", "No Surprises"];

export const Marquee = () => (
  <div className="border-y border-white/15 py-6 md:py-8 overflow-hidden" data-testid="editorial-marquee">
    <FastMarquee speed={22} gradient={false}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display text-3xl md:text-5xl uppercase font-medium tracking-tight text-paper px-6 md:px-10">
            {item}
          </span>
          <span className="w-2 h-2 bg-[#4361C2] rotate-45 inline-block" />
        </span>
      ))}
    </FastMarquee>
  </div>
);
